import { ADD_TICKET, DELETE_TICKET } from "./actionTypes";

export const addTicket = (value) => {
  return {
    type: ADD_TICKET,
    payload: value,
  };
};

export const deleteTicket = (id) => {
  return {
    type: DELETE_TICKET,
    payload: id,
  };
};
